import { message, Tooltip } from "antd";
import React, { useEffect, useState, useRef } from "react";
import { ReactMic } from "react-mic";
import AudioBtn from "../../assets/icon/audioBtn";
import DisabledMic from "../../assets/icon/disabledMic";
import StopRecIcon from "../../assets/icon/stopRecorderBtn.jsx";
import { HelperContext } from "../../store/helperStore";
import { RecorderContext } from "../../store/recorderStore";
import "./audioRecorder.scss";

export default function AudioRecorder({
  isAllowedRec,
  startRecording,
  stopRecording,
  isRecording,
  onStop,
  isDisableNext,
  isOneSecDone,
  isBufferTimeDone,
}) {
  const { helperC } = HelperContext();
  const { recorderC } = RecorderContext();
  const { isClipPlaying } = recorderC;
  const isAudioPlaying = helperC.audioQuePlay;
  // preventMove true when user tries to move ahead before 1sec
  const [preventMove, setPreventMove] = useState(false);
  // Switch btn. initial blue(play btn)
  const [switchRecordBtn, setSwtichRecordBtn] = useState(false);

  const preventMoveTimeoutId = useRef(null);

  useEffect(() => {
    console.log("useEffect audioRecorder");
    console.log("switchRecordBtn, isRecording", switchRecordBtn, isRecording);
    setTimeout(() => {
      setSwtichRecordBtn(isRecording);
    }, 1000);

    preventMoveTimeoutId.current &&
      !isRecording &&
      clearTimeout(preventMoveTimeoutId.current);
  }, [isRecording]);

  const handlePreventMove = () => {
    setPreventMove(true);
    // show prevent move text for 2 sec
    preventMoveTimeoutId.current = setTimeout(() => {
      setPreventMove(false);
    }, 2000);
  };

  // disable mic condition
  const disableMicCon = isClipPlaying || !isDisableNext || !isAllowedRec || isAudioPlaying;

  console.log(
    "datadata all",
    isClipPlaying || !isDisableNext || !isAllowedRec || isAudioPlaying
  );
  console.log("datadata isClipPlaying", isClipPlaying);
  console.log("datadata !isDisableNext", !isDisableNext);
  console.log("datadata !isAllowedRec", !isAllowedRec);
  console.log("datadata isAudioPlaying", isAudioPlaying);
  console.log("switchRecordBtn", switchRecordBtn);
  console.log("isBufferTimeDone", isBufferTimeDone);

  return (
    <>
     <div className="prevent-move-msg-blk">
        <p
          className="prevent-move-msg"
          style={{ opacity: preventMove ? 1 : 0 }}
        >
          Wait for Processing
        </p>
      </div>

      <div className="btn-group">
        {/* {!isRecording ? ( */}
        {!switchRecordBtn ? (
          <Tooltip
            title={
              !isDisableNext
                ? "Audio recorded"
                : !isAllowedRec
                ? "Please listen the audio first"
                : isClipPlaying
                ? "Stop the clip"
                : undefined
            }
          >
            <div className={`btn-blk ${!isDisableNext && "disable"}`}>
              <div
                className={`audio-play-button ${disableMicCon && "disable"}`}
                onClick={() => (disableMicCon ? undefined : startRecording())}
              >
                {disableMicCon ? <DisabledMic /> : <AudioBtn />}
              </div>
            </div>
          </Tooltip>
        ) : (
          <div className="btn-blk">
            <div
              className={"audio-play-button-animation"}
              onClick={() =>
                // isOneSecDone ? stopRecording() : handlePreventMove()
                isBufferTimeDone ? stopRecording() : handlePreventMove()
              }
            >
              <StopRecIcon />
            </div>
          </div>
        )}
      </div>
      <div style={{ display: "none" }}>
        <ReactMic
          record={isRecording}
          className=""
          onStop={(recordedBlob) => onStop(recordedBlob)}
          mimeType="audio/wav"
          strokeColor="#5f9ea0"
          backgroundColor="#dcdad7"
          width={300}
        />
      </div>
    </>
  );
}
